fragment TeamFields on Team {
  id
  name
  archived
  activeEmployeeCount
}
